/**
 * 섹션 — 위젯을 **질문 단위로** 묶는다.
 *
 * 위젯 6개를 그냥 나열하면 "이 페이지가 무슨 질문에 답하는지"가 사라진다.
 * P3 는 네 가지 질문에 순서대로 답한다:
 *   ① 이 숫자는 누구의 것인가 → ② 얼마나 믿을 수 있나
 *   → ③ 누구를 비교할 수 있나 → ④ 우리가 놓친 것은 무엇인가
 */

import type { ReactNode } from 'react'
import './Section.css'

interface Props {
  index: number
  title: string
  lead: string
  /** 'wide' 는 2열, 'full' 은 1열 전폭 */
  layout?: 'split' | 'full'
  children: ReactNode
}

export function Section({ index, title, lead, layout = 'split', children }: Props) {
  const id = `section-${index}`
  return (
    <section className="section" aria-labelledby={id}>
      <header className="section__head">
        <span className="section__index num" aria-hidden="true">
          {String(index).padStart(2, '0')}
        </span>
        <div>
          <h2 className="section__title" id={id}>
            {title}
          </h2>
          <p className="section__lead">{lead}</p>
        </div>
      </header>
      <div className={`section__body section__body--${layout}`}>{children}</div>
    </section>
  )
}
